/**
 * SessionRow — one indented "Session N + time + duration" line (CR-0015).
 */
import { fmtClock, fmtTime } from "@/utils/fmtTime";

export default function SessionRow({ session }) {
  return (
    <div
      data-testid={`session-row-${session.n}`}
      className="flex items-baseline justify-between py-1.5"
    >
      <div>
        <div className="text-sm font-semibold" style={{ color: "#111827" }}>
          Session {session.n}
        </div>
        <div className="text-xs" style={{ color: "#6B7280" }}>
          {fmtClock(session.timestamp_ist)}
        </div>
      </div>
      <div className="text-sm font-semibold" style={{ color: "#111827" }}>
        {fmtTime(session.seconds)}
      </div>
    </div>
  );
}
